import { RoleConfig } from 'ihub/common';
import { CRUDHelperBase } from '../classes/crud-helper-base';

export class RoleHttpService extends CRUDHelperBase<RoleConfig> {
	constructor() {
		super(RoleConfig.name);
	}
}
